import script from "./TimelinePoint.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelinePoint.vue?vue&type=script&setup=true&lang=js"

import "./TimelinePoint.vue?vue&type=style&index=0&id=e7472d48&lang=css"

const __exports__ = script;

export default __exports__